import Swiper from 'swiper/bundle';

import 'swiper/css';

export const groupSlider = () => {
  //if .group-slider doesn't exist, return

  const blocks = document.querySelectorAll('.wp-block-group.is-slider');

  // console.log(blocks);

  if (blocks.length === 0) return;

  blocks.forEach((block, i) => {
    //add class swiper to .hero-fader
    $(block).wrapInner('<div class="swiper"></div>');

    let swiperEl = $(block).find('.swiper');
    let isAutoplay = $(block).hasClass('is-slider-autoplay');

    //add class swiper-slide to each child of .hero-fader
    $(swiperEl).children().addClass('swiper-slide');

    //wrap all .swiper-slide in a .swiper-wrapper
    swiperEl.wrapInner('<div class="swiper-wrapper"></div>');

    swiperEl.append('<div class="swiper-pagination"></div>');
    swiperEl.append('<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>');

    // console.log(swiperEl);
    new Swiper(swiperEl[0], {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 32,
      autoplay: isAutoplay
        ? {
            delay: 5000,
            disableOnInteraction: false,
            reverseDirection: true,
          }
        : false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' + ' of ' + '<span class="' + totalClass + '"></span>';
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function () {
          // console.log('initialized.'); // this works
          //setAlignFullCssVar();
        },
      },
    });
  });
};
